"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelloWorld = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var core_1 = require("../../../shared/core");
var copy_1 = require("../copy");
var HeroArt = function () {
    var colors = (0, react_1.useContext)(styled_components_1.ThemeContext).colors;
    return (react_1.default.createElement("svg", { fill: "none", viewBox: "0 0 173 170" },
        react_1.default.createElement("path", { fill: colors.primary, d: "M86.1 69.84A14.69 14.69 0 0 1 93.83 72a14.77 14.77 0 0 1-8 27.35 14.45 14.45 0 0 1-7.62-2.16 14.8 14.8 0 0 1 7.89-27.35Zm0-11a25.8 25.8 0 0 0-13.7 47.7 25.391 25.391 0 0 0 13.48 3.85 25.762 25.762 0 0 0 24.983-18.583A25.763 25.763 0 0 0 99.7 62.74a25.59 25.59 0 0 0-13.6-3.9Z" }),
        react_1.default.createElement("path", { fill: colors.border, d: "M125.28 109.3a46.54 46.54 0 0 0-4.37-55.3 11.437 11.437 0 0 0-4.17-14 11.001 11.001 0 0 0-13.52 1.46 46.39 46.39 0 0 0-41.83 82.4 44.005 44.005 0 0 0 20.19 6.87 10.218 10.218 0 0 0 4.42 5.41 10.819 10.819 0 0 0 15-3.54 10.12 10.12 0 0 0 1.66-4.58 46.671 46.671 0 0 0 22.62-18.72Zm-20.19-50.78a11 11 0 0 0 12.28-.41 41.22 41.22 0 0 1 3.33 48.27 40.639 40.639 0 0 1-18.94 16 11.407 11.407 0 0 0-4.16-4.79 10.819 10.819 0 0 0-15 3.54 10.367 10.367 0 0 0-1.6 4.19 43.172 43.172 0 0 1-16.64-6 40.928 40.928 0 0 1 6.706-72.572 40.93 40.93 0 0 1 29.294-.428 10.88 10.88 0 0 0 4.73 12.2Z" }),
        react_1.default.createElement("path", { fill: colors.border, d: "M166.89 64.35a13.157 13.157 0 0 0 3.54-3.35 11.103 11.103 0 0 0-3.54-15.19 11.471 11.471 0 0 0-7.7-1.46A83.999 83.999 0 0 0 129.65 13a85.13 85.13 0 0 0-94.89 3.12h-.21a11.05 11.05 0 0 0-15.19 3.28 11.28 11.28 0 0 0 0 11.45 96.24 96.24 0 0 0-6.45 8.95 84.43 84.43 0 0 0 16.65 109 10.92 10.92 0 0 0 4.16 13.74 10.996 10.996 0 0 0 13.94-1.88 84.592 84.592 0 0 0 86.34-7.25l.62.21a10.798 10.798 0 0 0 15-3.33 11.176 11.176 0 0 0 .21-11.65 79.946 79.946 0 0 0 6.66-9.16 85.15 85.15 0 0 0 10.4-65.13ZM50.16 155.91a10.78 10.78 0 0 0-4.79-11.86 11.327 11.327 0 0 0-12.48.41 79.17 79.17 0 0 1-15.4-102c1.87-2.7 3.74-5.41 5.62-7.7a11.26 11.26 0 0 0 15-3.74 11.13 11.13 0 0 0 .41-10.82 79.13 79.13 0 0 1 88.23-2.71 80.093 80.093 0 0 1 27.45 29.17 14.578 14.578 0 0 0-2.29 2.71 10.798 10.798 0 0 0 3.33 15 10.359 10.359 0 0 0 6.45 1.63 78.46 78.46 0 0 1-10 60.56 59.407 59.407 0 0 1-5.82 8.32 10.997 10.997 0 0 0-14.78 3.75 11.306 11.306 0 0 0-.62 10.61 79.38 79.38 0 0 1-80.31 6.67Z" }),
        react_1.default.createElement("path", { fill: colors.border, d: "M119.66 29.39a66.17 66.17 0 0 0-35.79-10 11.52 11.52 0 0 0-4.16-4.78 11.12 11.12 0 0 0-15.2 3.53 11.82 11.82 0 0 0-1.66 5.21A65 65 0 0 0 19.57 81a9.19 9.19 0 0 0-5.83 4.57 10.81 10.81 0 0 0 3.33 15 13.679 13.679 0 0 0 4.58 1.66 65.55 65.55 0 1 0 98-72.83l.01-.01Zm-51.61 4a11 11 0 0 0 15-3.53A8.35 8.35 0 0 0 84.7 25a60.002 60.002 0 0 1 59.831 65.503 60.002 60.002 0 0 1-70.79 53.472 59.999 59.999 0 0 1-46.68-42.605A10.589 10.589 0 0 0 32.26 97a10.847 10.847 0 0 0-3.54-15A9.191 9.191 0 0 0 25 80.58a58.709 58.709 0 0 1 9-27.47 59.75 59.75 0 0 1 30-24.34 12.27 12.27 0 0 0 4.05 4.57v.05Z" })));
};
var HelloWorld = function () {
    var _a, _b;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, Heading2 = _c.Heading2, PrimaryCTAButton = _c.PrimaryCTAButton, Stack = _c.Stack, Row = _c.Row, Col = _c.Col;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var dispatch = (0, ui_tools_1.useEvents)().dispatch;
    var _d = __read((0, react_1.useState)(0), 2), count = _d[0], setCount = _d[1];
    var clickEventHandler = function () {
        setCount(count + 1);
        dispatch('hello-world-event', { helloType: 'cheerful' });
    };
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: "hello-world-card", properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Row, { isNested: true },
                    react_1.default.createElement(Col, { small: 9 },
                        react_1.default.createElement(Heading2, null,
                            react_1.default.createElement(Copy, { copyKey: "heading" })),
                        react_1.default.createElement(Copy, { copyKey: "body" }),
                        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: "hello-world-cta", properties: (_b = {
                                    exampleProperty: 'someValue'
                                },
                                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                                _b) },
                            react_1.default.createElement(PrimaryCTAButton, { onClick: clickEventHandler },
                                react_1.default.createElement(Copy, { copyKey: "ctaText" }),
                                count ? " (".concat(count, ")") : null))),
                    react_1.default.createElement(Col, { small: 3 },
                        react_1.default.createElement(ui_tools_1.Sandwich, { id: "hello-world-image" },
                            react_1.default.createElement(HeroArt, null))))),
            react_1.default.createElement(core_1.Feature, { feature: "helloWorldWelcome" }, function (variant) {
                return variant ? (react_1.default.createElement(Card, null,
                    react_1.default.createElement(Heading2, null,
                        react_1.default.createElement(Copy, { copyKey: "featureHeading" })),
                    react_1.default.createElement(Copy, { copyKey: "featureBody" }))) : null;
            }))));
};
exports.HelloWorld = HelloWorld;
